import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFrHomeBody from "./Components/BodyFrHome";
class CHFRHome extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFrHomeBody />
        <Footer />
      </>
    );
  }
}

export default CHFRHome;
